export default __webpack_public_path__ + "static/ringType3-f39d750db69950e78a4fa3d16a6def0d.png";